import template from './denomination.all.html';
import controller from './denomination.all.controller';
import './denomination.all.scss';

let denominationallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default denominationallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/all/denomination.all.component.js